var _defs, _g;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgMessageManagement(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "1284.614 4294.792 105.482 120.948",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, "\n      .cls-1, .cls-2 {\n        fill: #a8a8a8;\n      }\n\n      .cls-2 {\n        font-size: 23px;\n        font-family: Arial-Black, Arial Black;\n        font-weight: 800;\n      }\n\n      .cls-3 {\n        fill: none;\n        stroke: #a8a8a8;\n        stroke-width: 6px;\n      }\n    "))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group_288",
    "data-name": "Group 288",
    transform: "translate(395 2343)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_355",
    "data-name": "Path 355",
    className: "cls-1",
    d: "M125.421,99.2h0a6.421,6.421,0,1,0,0,12.842h0a6.421,6.421,0,0,0,0-12.842Z",
    transform: "translate(794.361 1890.637)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_355-2",
    "data-name": "Path 355",
    className: "cls-1",
    d: "M125.421,99.2h0a6.421,6.421,0,1,0,0,12.842h0a6.421,6.421,0,0,0,0-12.842Z",
    transform: "translate(816.95 1890.637)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_355-3",
    "data-name": "Path 355",
    className: "cls-1",
    d: "M125.421,99.2h0a6.421,6.421,0,1,0,0,12.842h0a6.421,6.421,0,0,0,0-12.842Z",
    transform: "translate(839.539 1890.637)"
  }), /*#__PURE__*/React.createElement("text", {
    id: "Login",
    className: "cls-2",
    transform: "translate(907.414 2065.739)"
  }, /*#__PURE__*/React.createElement("tspan", {
    x: 0,
    y: 0
  }, "Login")), /*#__PURE__*/React.createElement("path", {
    id: "Path_449",
    "data-name": "Path 449",
    className: "cls-3",
    d: "M726.291,4108.792c24.873,0,50.531,18.53,49.787,42.109a36.255,36.255,0,0,1-3.663,14.614,42.552,42.552,0,0,1-5.788,8.856c-1.668,2,7.114,19.078,5.374,20.752-.217.209-21.864-8.046-23.916-7.13a54.454,54.454,0,0,1-21.794,4.6c-24.873,0-49.794-18-49.677-41.692S701.418,4108.792,726.291,4108.792Z",
    transform: "translate(216 -2154)"
  }))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgMessageManagement);
export default __webpack_public_path__ + "static/media/message_management.7ef1b524eee4fdb26f7bf9b4635cdc47.svg";
export { ForwardRef as ReactComponent };